module.exports = __webpack_public_path__ + "img/logo.a30e3bdf.png";